globalThis._ = require('lodash')
globalThis.Vue = require('vue')
globalThis.Vuex = require('vuex')
globalThis.VueRouter = require('vue-router')
globalThis._env_ = _.merge({}, process.env, globalThis._env_ || {})
globalThis.requires = require('@/utils/requires').default
globalThis.$util = require('@slicejobs/util-js-lib').default
globalThis.appEvent = require('./appEvent').default
globalThis.validator = require('./validator').default
globalThis.filter = require('@/filters').default
globalThis.$model = require('@/models').default
globalThis.store = require('@/store').default
globalThis.http = require('./http').default
globalThis.request = require('@/config/request.config').request
globalThis.auth = require('@/config/auth.config').auth
globalThis.DefaultLayout = require('@/layouts/default/DefaultLayout').default
globalThis.router = require('./router').default

/**
 * Mock.js
 * 生成随机数据，拦截 Ajax 请求
 * 通过覆盖和模拟原生 XMLHttpRequest 的行为来拦截 Ajax 请求
 * http://mockjs.com/
 */
if (process.env.NODE_ENV === 'development' && globalThis._env_.VUE_APP_MOCK_API === 'true') {
  globalThis.Mock = require('mockjs')
}
